<template>
  <div class="login-page">
    <div class="login-container">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12">
              <img
                src="@/assets/images/Al_Wasiyyat_Logo.png"
                alt=""
                class="login-logo"
              />
            </div>
            <div class="col-md-4" id="nominee">
              <img
                src="@/assets/images/Nominee.png"
                alt="Nominee"
                width="50"
                height="50"
              />
              <p>Products</p>
            </div>
            <div class="col-md-4" id="finance">
              <img
                src="@/assets/images/Finance.png"
                alt="Finance"
                width="50"
                height="50"
              />
              <p>Application</p>
            </div>
            <div class="col-md-4" id="application">
              <img
                src="@/assets/images/Application.png"
                alt="Application"
                width="50"
                height="50"
              />
              <p>Help Desk</p>
            </div>
          </div>

          <!-- General Form -->
          <div class="general" v-if="formType === 'general'">
            <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
              <div class="col-md-12">
                <b-form-group label-for="username">
                  <b-form-input
                    id="user_name"
                    v-model="formData.username"
                    placeholder="Username"
                    class="form-control"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group label-for="password">
                  <b-form-input
                    id="password"
                    type="password"
                    v-model="formData.password"
                    placeholder="Password"
                    class="form-control"
                    required
                  ></b-form-input>
                  <div
                    class="text-end mt-3 text-dark text-decoration-none hoverClass"
                  >
                    <small
                      ><a
                        @click="alertMessage"
                        class="text-dark text-decoration-none hoverable"
                        href="#"
                        >Forgot Password?</a
                      ></small
                    >
                  </div>
                </b-form-group>
              </div>
              <div class="col-md-12 d-grid gap-2 mt-4">
                <button
                  type="submit"
                  class="btn text-white"
                  style="background-color: #077747"
                >
                  Login
                </button>
              </div>
              <div class="col-md-12 mb-3 text-center mt-5">
                New To Wasiyyah?
                <a @click="redirectToRegister" class="btn btn-link text-success"
                  >Register Now</a
                >
              </div>
            </b-form>
          </div>

          <!-- Nominee Form -->
          <div class="general" v-if="formType === 'nominee'">
            <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
              <div class="col-md-12">
                <b-form-group label-for="nomineeUsername">
                  <b-form-input
                    id="nominee_user_name"
                    v-model="formData.username"
                    placeholder="Enter Nominee Username"
                    class="form-control"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group label-for="nomineePassword">
                  <b-form-input
                    id="nominee_password"
                    v-model="formData.password"
                    placeholder="Enter Nominee Password"
                    class="form-control"
                    type="password"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12 d-grid gap-2 mt-4">
                <button
                  type="submit"
                  class="btn text-white"
                  style="background-color: #077747"
                >
                  Nominee Login
                </button>
              </div>
              <div class="col-md-12 mb-3 text-center mt-5">
                New To Wasiyyah?
                <a @click="redirectToRegister" class="btn btn-link text-success"
                  >Register Now</a
                >
              </div>
            </b-form>
          </div>

          <!-- Products Form -->
          <div class="general" v-if="formType === 'products'">
            <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
              <div class="col-md-12">
                <b-form-group label-for="productsUsername">
                  <b-form-input
                    id="products_user_name"
                    v-model="formData.username"
                    placeholder="Enter Products Username"
                    class="form-control"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group label-for="productsPassword">
                  <b-form-input
                    id="products_password"
                    v-model="formData.password"
                    placeholder="Enter Products Password"
                    class="form-control"
                    type="password"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12 d-grid gap-2 mt-4">
                <button
                  type="submit"
                  class="btn text-white"
                  style="background-color: #077747"
                >
                  Products Login
                </button>
              </div>
              <div class="col-md-12 mb-3 text-center mt-5">
                New To Wasiyyah?
                <a @click="redirectToRegister" class="btn btn-link text-success"
                  >Register Now</a
                >
              </div>
            </b-form>
          </div>

          <!-- Application Form -->
          <div class="general" v-if="formType === 'apply'">
            <b-form @submit.prevent="onSubmit" @reset.prevent="onReset">
              <div class="col-md-12">
                <b-form-group label-for="applicationUsername">
                  <b-form-input
                    id="application_user_name"
                    v-model="formData.username"
                    placeholder="Enter Application Username"
                    class="form-control"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12">
                <b-form-group label-for="applicationPassword">
                  <b-form-input
                    id="application_password"
                    v-model="formData.password"
                    placeholder="Enter Application Password"
                    class="form-control"
                    type="password"
                    required
                  ></b-form-input>
                </b-form-group>
              </div>
              <div class="col-md-12 d-grid gap-2 mt-4">
                <button
                  type="submit"
                  class="btn text-white"
                  style="background-color: #077747"
                >
                  Application Login
                </button>
              </div>
              <div class="col-md-12 mb-3 text-center mt-5">
                New To Wasiyyah?
                <a @click="redirectToRegister" class="btn btn-link text-success"
                  >Register Now</a
                >
              </div>
            </b-form>
          </div>
        </div>
        <div class="col-md-6">
          <div
            id="carouselExampleControls"
            class="carousel slide"
            data-bs-ride="carousel"
          >
            <div class="carousel-inner">
              <div class="carousel-item active">
                <img
                  src="@/assets/images/LoginPageimage.jpg"
                  alt=""
                  width="400px"
                  height="500px"
                />
              </div>
              <!--<div class="carousel-item">
                              <img src="@/assets/images/LoginPageimage.jpg" alt="" width="400px" height="500px">
                            </div>
                            <div class="carousel-item">
                              <img src="@/assets/images/LoginPageimage.jpg" alt="" width="400px" height="500px">
                            </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiRepository from "@/services/ApiRepository";
import { toast } from "vue3-toastify";

export default {
  name: "LogIn",
  data() {
    return {
      formData: {
        username: "",
        password: "",
        ip: "",
      },

      formType: "general", // Default form type
    };
  },
  mounted() {
    fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        this.formData.ip = data.ip;
        console.log("User IP:", this.userIp);
      })
      .catch((error) => {
        console.error("Failed to fetch IP:", error);
      });
  },
  methods: {
    setFormType(type) {
      this.formType = type; // Set the form type based on the clicked option
    },
    alertMessage() {
      toast.warning(
        "For your security, password reset is only allowed through the Wasiyyah mobile application."
      );
    },
    onSubmit() {
      if (this.formData.username && this.formData.password) {
        apiRepository
          .callApi(apiRepository.POST_COMMAND, `/user/login`, this.formData)
          .then((res) => {
            if (res.data.statusCode === 200 && res.data.data?.token) {
              toast.success(res.data.message || "Login successful");
              localStorage.setItem("authToken", res.data.data.token);
              this.$router.push({ name: "Dashboard" });
              window.location.reload();
            } else {
              toast.error(
                res.data.message || "Failed to log in. Please try again."
              );
            }
          })
          .catch((error) => {
            const errorMessage =
              error.response?.data?.message ||
              error.message ||
              "An error occurred during login.";
            toast.error(`Error: ${errorMessage}`);
          });
      } else {
        toast.error("Enter Your User Credential!");
      }
    },
    onReset() {
      this.formData = {
        username: "",
        password: "",
      };
    },
    redirectToRegister() {
      this.$router.push({ name: "SignUp" });
    },
  },
};
</script>

<style scoped>
/* Add your custom styles here */
#nominee p:hover {
  cursor: pointer;
  color: #077747;
}

#finance p:hover {
  cursor: pointer;
  color: #077747;
}

#application p:hover {
  cursor: pointer;
  color: #077747;
}
</style>
